import { Icon } from './_Icon';
export const PlugIcon = (props) => (
  <Icon {...props} d="M9 2v6 M15 2v6 M6 8h12v4a6 6 0 0 1-12 0z M12 18v4" />
);
